import { WidgetPos } from "../types";
import { clamp } from "./clamp";

export function getWidgetSnapPosition(
  widget: WidgetPos,

  unitSize: number,
  absolutePosition: {
    x: number;
    y: number;
  },
  numberOfColumns: number = 4,
  numberOfRows: number = 4
) {
  "worklet";
  const horizontal = clamp(
    Math.round(Math.abs(absolutePosition.x) / unitSize),
    0,
    7
  );
  const c = clamp(Math.floor(horizontal / 2), 0, numberOfColumns);
  const x = widget.w === 1 ? horizontal % 2 : 0;
  const y = clamp(Math.round(absolutePosition.y / unitSize), 0, numberOfRows);
  return { c, x, y };
}
